import { useState } from "react";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

import useAccountChangePasswordData from "@usas/ui-web/state/account/accountChangePassword/UseAccountChangePasswordData";

const INITIAL_API_ERROR_POPUP_STATE = {
  displayPopup: false,
  errorMessage: ''
};

//TODO delete?
const useAccountCreationChangePassword = () => {
  const { accountCreationState, resetAccountCreationState } = useAccountCreationData();
  const { accountChangePasswordState, postAccountChangePassword, resetAccountChangePasswordState
  } = useAccountChangePasswordData();
  const [apiErrorPopupState, setAPIErrorPopupState] = useState(INITIAL_API_ERROR_POPUP_STATE);

  const onCancelClicked = () => {
    resetAccountCreationState(); // clears state and sends back to login
  };

  const onCloseAPIErrorPopupClicked = () => {
    resetAccountChangePasswordState();
    setAPIErrorPopupState(INITIAL_API_ERROR_POPUP_STATE);
  };

  const onSubmitFormCallback = (formState) => {
    const href = accountCreationState.forgotPasswordData?.href;
    const newPassword = formState.newPassword;
    const recoveryCode =  formState.recoveryCode;

    const postAccountChangePasswordPromise = postAccountChangePassword(href, newPassword, recoveryCode);

    if (postAccountChangePasswordPromise ?? false) {
      postAccountChangePasswordPromise.then((newState) => {
        if (newState ?? false) {
          if (newState.objData?.errorMessage === null) {
            resetAccountCreationState(); // clears state and sends back to login
          } else {
            setAPIErrorPopupState({
              ...apiErrorPopupState,
              displayPopup: true,
              errorMessage: newState.objData.errorMessage
            });
          }
        }
      }).catch((e) => {
        setAPIErrorPopupState({
          ...apiErrorPopupState,
          displayPopup: true,
          errorMessage: e?.message
        });
      });
    }
  };

  return {
    isLoading: accountChangePasswordState.isObjLoading,
    username: accountCreationState.forgotPasswordData?.username,
    apiErrorPopupState,
    onSubmitFormCallback,
    onCancelClicked,
    onCloseAPIErrorPopupClicked,
  };
};

export default useAccountCreationChangePassword;